
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useContents from "customHooks/useContents";
import useHeaderTitleSetter from "customHooks/useHeaderTitleSetter";
import useMobile from "customHooks/useMobile";
import StaticLayout from "layout/StaticLayout";
import { useRouter } from "next/router";
import { AboutLayoutProps } from "pages/about";
import { getStaticPagesLayoutData } from "ssrUtils";
const Terms: React.FC<AboutLayoutProps> = ({ pages }) => {
    const conts = useContents();
    const { locale } = useRouter();
    const serverTerms = pages.find((page) => page.slug === "terms");
    const terms = conts?.data?.pages?.find((page) => page.slug === "terms")?.contents;
    const termsBody = terms?.body?.[locale];
    const title = serverTerms?.[locale];
    useHeaderTitleSetter({ title, section: "" });
    const isMobile = useMobile("md");
    return (<div className={isMobile && "container px-4 mt-3"}>
      <div className="mt-4 about-child" dangerouslySetInnerHTML={{ __html: termsBody }}/>
    </div>);
};
export default Terms;
(Terms as any).Layout = StaticLayout;
const getStaticProps = getStaticPagesLayoutData;

    async function __Next_Translate__getStaticProps__1a13f66c02b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/help/terms',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66c02b__ as getStaticProps }
  